export let showAdminBar = false;

const callbacks: (() => void)[] = [];
export function addChangesShowAdminBarCallback(cb: () => void) {
  callbacks.push(cb);
}

export function removeCb(cb: () => void) {
  if (callbacks.indexOf(cb) > -1) {
    callbacks.slice(callbacks.indexOf(cb), 1);
  }
}

function change() {
  callbacks.forEach((cb) => cb());
}

export function initShowAdminBar() {
  (window as any).showAdminBarocska = function () {
    showAdminBar = true;
    change();
  };
  (window as any).hideAdminBarocska = function () {
    showAdminBar = false;
    change();
  };
}
